<div class="flex flex-wrap gap-4 my-4 justify-between items-center border border-solid px-3 py-4 rounded-xl">
  <div class="flex items-center">
    <div class="dark-overlay before:rounded-full animate-pulse block w-[48px] h-[48px] rounded-full mx-2"></div>
    <div class="flex flex-col">
      <div class="dark-overlay animate-pulse block w-[58px] h-[16px] rounded-full"></div>
      <div class="dark-overlay animate-pulse block w-[100px] h-[16px] rounded-full mt-2"></div>
    </div>
  </div>

  <div class="flex items-center">
    <div class="flex flex-col items-start">
      <div class="dark-overlay animate-pulse block w-[80px] h-[23px] rounded-full"></div>
      <div class="dark-overlay animate-pulse block w-[190px] h-[24px] rounded-full mt-[10px]"></div>
    </div>

  </div>
</div>
